export default "__VITE_ASSET__BEKjHb3$__"